import { colorBands } from "src/organization/pages/project/environment/metrics/constant";

import { findMetricsValue } from "../impact/util";
import { HttpMetricsType } from "../types";

export const getBandwidthMetrics = (httpMetrics: HttpMetricsType[]) => {
  return httpMetrics.map(metrics => ({
    ...metrics,
    request: findMetricsValue(metrics, "request.bytes")?.sum,
    response: findMetricsValue(metrics, "response.bytes")?.sum,
    totalBandWidth: findMetricsValue(metrics, "bandwidth.total.bytes")?.sum
  }));
};

export const bandwidthColorBand = {
  request: colorBands[6],
  response: colorBands[8]
};

export const bandwidthOption = ["request", "response"];
